import { Skeleton } from 'antd'
import React from 'react'

export const LoadingPlaceholder = ({
  isLoading = false,
  component = (
    <Skeleton
      active={true}
      isLoading={true}
      paragraph={{
        rows: 2,
      }}
    />
  ),
  children,
}) => {
  return isLoading ? component : children
}

export const renderLoading = (isLoading, children, params) => (
  <LoadingPlaceholder
    isLoading={isLoading}
    {...(params ?? {})}>
    {children}
  </LoadingPlaceholder>
)
